(() => {
  if (customElements.get('infinite-loading')) {
    return;
  }

  class InfiniteLoading extends HTMLElement {
    static LOADING_CLASS = 'is-loading';

    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
      this.initIntersection();
    }

    disconnectedCallback() {
      this.removeComponent();
    }

    init() {
      this.url = this.dataset.url;
      this.productsContainer = this.closest('[data-parent-container]').querySelector('[data-items]');
    }

    initIntersection() {
      const handleIntersection = (entries) => {
        if (!entries[0].isIntersecting) {
          return;
        }

        if (this.classList.contains(InfiniteLoading.LOADING_CLASS)) {
          return;
        }

        this.fetchContent();
      };

      this.observer = new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 400px 0px',
      });

      this.observer.observe(this);
    }

    fetchContent() {
      if (!this.url) {
        return;
      }

      this.classList.add(InfiniteLoading.LOADING_CLASS);

      fetch(this.url)
        .then((response) => response.text())
        .then((response) => {
          const html = new DOMParser().parseFromString(response, 'text/html');
          const productsContainer = html.querySelector('[data-items]');
          const infiniteLoadingComponent = html.querySelector('infinite-loading');

          if (productsContainer) {
            this.appendItems(productsContainer);
          }

          if (infiniteLoadingComponent) {
            this.updateComponentData(infiniteLoadingComponent);
          } else {
            this.removeComponent();
          }
        })
        .catch((e) => {
          console.error(e);

          this.removeComponent();
        })
        .finally(() => {
          this.classList.remove(InfiniteLoading.LOADING_CLASS);
        });
    }

    appendItems(section) {
      const productCards = section.querySelectorAll('[data-product-card], [data-item-card]');

      productCards.forEach((productCard) => this.productsContainer.append(productCard));
    }

    updateComponentData(component) {
      this.url = component.dataset.url;
      this.dataset.url = component.dataset.url;
    }

    removeComponent() {
      this.observer?.unobserve(this);

      this.remove();
    }
  }

  customElements.define('infinite-loading', InfiniteLoading);
})();
